import { diff, detailedDiff as innerDetailedDiff } from 'deep-object-diff';
// WARNING: diff values will not contain Arrays, but an object-map with numeric indexes of *changed* array entries!
export function getDiff(newObj, oldObj) {
  return diff(oldObj, newObj);
}
export function detailedDiff(updated, old) {
  return innerDetailedDiff(old, updated);
}
export function diffIsEmpty(diff, types = ['added', 'deleted', 'updated']) {
  for (const key of types) {
    if (Object.keys(diff[key]).length > 0) return false;
  }
  return true;
}